module.exports = __webpack_public_path__ + "img/LITERATURA.196cb0c4.png";